import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const IntegrationFooterWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 ${Spacing.S24};
  border-radius: ${Spacing.S12};
  background-color: ${Color.Orange50};
`

export const IntegrationFooterImageWrapper = styled.div`
  max-width: 182px;
`

export const IntegrationFooterLinkWrapper = styled.div`
  display: flex;
`
